export default __webpack_public_path__ + "static/media/custom_report.465ba4e8.png";